import React from "react";
import { Grid2 } from "@mui/material";
import YouTube from "react-youtube";
import PageTitle from "../../../components/Common/PageTitle/index";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  YOUTUBE_OPTS,
  VIEW_MORE_LINK,
  VIEW_MORE_LABEL,
  MDITATION_VIDEOS,
} from "./Meditations.constants";
import {
  RootBox,
  VideosGrid,
  YouTubeWrapper,
  ViewMoreButtonWrapper,
  ViewMoreIcon,
} from "./Meditations.styles";
import { SecondaryBtn } from "../../../components/Common/CustomBtn";
import { colors } from "../../../theme/theme";
import { Gapper } from "../../../components/ui/Gapper";
const Meditations = () => {
  const handleViewMore = () => window.open(VIEW_MORE_LINK, "_blank");

  return (
    <RootBox>
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />
      <Gapper gap={30}>
        <VideosGrid container spacing={2}>
          {MDITATION_VIDEOS.map((item) => (
            <Grid2 item key={item.id} size={{ xs: 12, sm: 6 }}>
              <YouTubeWrapper>
                <YouTube videoId={item.video} opts={YOUTUBE_OPTS} />
              </YouTubeWrapper>
            </Grid2>
          ))}
        </VideosGrid>
        <ViewMoreButtonWrapper>
          <SecondaryBtn
            Icon={ViewMoreIcon}
            text={VIEW_MORE_LABEL}
            iconColor={colors.secondary}
            onClick={handleViewMore}
          />
        </ViewMoreButtonWrapper>
      </Gapper>
    </RootBox>
  );
};

export default Meditations;
